// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageNotFound_wrapper__2tAH4","title":"PageNotFound_title__3ralh","text":"PageNotFound_text__1XLqI","link":"PageNotFound_link__u6H27"};